<div class="contact-host">
  <button type="button" (click)="openModal()" class="cnt-button-secondary w-button">
    <div class="cnt-button-mock">Contact Host</div>
  </button>
</div>
